import { render } from "./ReviewCompleteCard.vue?vue&type=template&id=0a89f83b"
import script from "./ReviewCompleteCard.vue?vue&type=script&lang=js"
export * from "./ReviewCompleteCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__